// ChannelPostForm.jsx

import React from 'react';

// Components
import AiPromptComposer from 'spaces/components/AiPromptComposer';

/**
 * ChannelPostForm
 *
 * Channel chrome around the shared Ai / Capture prompt composer.
 *
 * @returns {ReactNode}
 */
const ChannelPostForm = React.memo((props) => (
  <AiPromptComposer
    {...props}
    surface="channel"
  />
));

// Dev Tools
ChannelPostForm.displayName = 'ChannelPostForm';

export default ChannelPostForm;
